module.exports = __webpack_public_path__ + "img/Brunei Darussalam.986176d0.gif";